import { ArrowLeft, ArrowRight, CheckCircle2, CircleDot, Users } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import PageMeta from '../components/PageMeta';
import ProductDemo from '../components/demos/ProductDemo';
import ProductMark from '../components/ProductMark';
import { getProductBySlug, products } from '../data/products';
import NotFoundPage from './NotFoundPage';

const ProductPage = () => {
  const { slug } = useParams();
  const product = getProductBySlug(slug);
  if (!product) return <NotFoundPage />;
  const otherProducts = products.filter((item) => item.slug !== slug);

  return (
    <>
      <PageMeta title={`${product.name} — Jupiter Cosmic`} description={product.metaDescription} />
      <main id="main-content" className="product-page" data-product={product.accent}>
        <section className="product-hero section-dark">
          <Link className="back-link" to="/#products"><ArrowLeft aria-hidden="true" /> All products</Link>
          <div className="product-hero-grid">
            <div><div className="development-label"><CircleDot aria-hidden="true" /> In development</div><div className="product-title"><ProductMark product={product} size="lg" /><p>{product.name}</p></div><p className="eyebrow">{product.eyebrow}</p><h1>{product.headline}</h1><p className="hero-description">{product.description}</p><Link className="button button--light" to={`/?product=${product.slug}#pilot`}>Discuss a {product.shortName} pilot <ArrowRight aria-hidden="true" /></Link></div>
            <ProductDemo slug={product.slug} />
          </div>
        </section>

        <section className="detail-section section-light">
          <div className="section-heading split-heading"><p className="eyebrow">Built for real operations</p><div><h2>One workflow, observable from signal to decision.</h2><p>Start with a focused sample, then evaluate together whether the output truly helps your team move faster and with more clarity.</p></div></div>
          <div className="audience-row"><Users aria-hidden="true" /><span>Designed for</span>{product.users.map((user) => <strong key={user}>{user}</strong>)}</div>
        </section>

        <section className="capabilities-section section-light">
          <div className="capabilities-copy"><p className="eyebrow">Planned capabilities</p><h2>The system we are building.</h2><p>These represent our development direction, not generally available features.</p></div>
          <ol>{product.capabilities.map((capability, index) => <li key={capability}><span>0{index + 1}</span><p>{capability}</p></li>)}</ol>
        </section>

        <section className="review-section section-dark">
          <div><p className="eyebrow">Human verification layer</p><h2>Output is not the final decision.</h2><p>Every result is designed to be traceable, reviewable, and correctable before any important action takes place.</p></div>
          <ol>{product.reviewSteps.map((step, index) => <li key={step}><CheckCircle2 aria-hidden="true" /><span>0{index + 1}</span><strong>{step}</strong></li>)}</ol>
        </section>

        <section className="product-cta section-light"><ProductMark product={product} size="lg" /><p className="eyebrow">Focused pilot</p><h2>Working with a similar signal gap?</h2><p>Share a real example from your team. We will help assess whether {product.name} is relevant for a focused pilot.</p><Link className="button" to={`/?product=${product.slug}#pilot`}>Request a pilot discussion <ArrowRight aria-hidden="true" /></Link></section>

        <section className="more-products section-light"><p className="eyebrow">Continue exploring</p><div>{otherProducts.map((item) => <Link key={item.slug} to={`/products/${item.slug}`} data-product={item.accent}><ProductMark product={item} /><span><small>{item.eyebrow}</small><strong>{item.name}</strong></span><ArrowRight aria-hidden="true" /></Link>)}</div></section>
      </main>
    </>
  );
};

export default ProductPage;
